import { CellContext } from '@tanstack/react-table';
import { BuslineQueryData } from '@area-restrita/api-client/model/buslineQueryData';
import Dialog from '@/components/template/Dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { DialogFooter } from '@/components/ui/dialog';
import { toast } from 'react-toastify';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { useDeleteBusline } from '@area-restrita/api-client/endpoints/buslines/buslines.gen';
import React from 'react';

type IProps = CellContext<BuslineQueryData, unknown>;

const BuslineActionsCell: React.FC<IProps> = ({ row }) => {
  const { checkAuthorization } = useAuthSessionStore();

  const canDelete = checkAuthorization(({ can }) => can('delete', 'fleets'));

  const { mutate: deleteBusline } = useDeleteBusline();

  return (
    <Dialog
      title="Excluir Rota"
      tooltipContent="Excluir rota"
      trigger={
        <Button variant="destructive" size="icon-sm" disabled={!canDelete}>
          <Trash2 className="h-4 w-4" />
        </Button>
      }
    >
      {({ handleClose }) => (
        <>
          <p>
            Tem certeza que deseja excluir a rota{' '}
            <strong>{row.original.name}</strong>?
          </p>
          <DialogFooter>
            <Button
              variant="destructive"
              size="sm"
              onClick={() =>
                deleteBusline(
                  { id: row.original.id },
                  {
                    onSuccess: () =>
                      toast.success('Rota excluída com sucesso!'),
                    onError: ({ message }) =>
                      toast.error(message || 'Erro ao excluir rota!'),
                    onSettled: () => handleClose(),
                  },
                )
              }
            >
              Excluir
            </Button>
          </DialogFooter>
        </>
      )}
    </Dialog>
  );
};

export default BuslineActionsCell;
